module.exports = __webpack_public_path__ + "static/media/bgvideo_m.a4a4c7e6.mp4";